import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-eye-crossed',
  templateUrl: './icon-eye-crossed.component.html',
  styleUrls: ['./icon-eye-crossed.component.scss'],
})
export class IconEyeCrossedComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
